import colors from 'styles/colors';

const Cross = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={colors.secondary.deepCove}
        d="M11.927 1.77705C11.927 1.2009 12.3941 0.733837 12.9702 0.733837H13.0298C13.6059 0.733837 14.073 1.2009 14.073 1.77705L14.073 24.2227C14.073 24.7989 13.6059 25.266 13.0297 25.266H12.9702C12.3941 25.266 11.927 24.7989 11.927 24.2227V1.77705Z"
      />
      <path
        fill={colors.secondary.deepCove}
        d="M1.77715 14.0729C1.201 14.0729 0.73394 13.6058 0.73394 13.0296L0.733942 12.9701C0.733942 12.394 1.201 11.9269 1.77715 11.9269L24.2228 11.9269C24.799 11.9269 25.2661 12.394 25.2661 12.9701L25.2661 13.0296C25.2661 13.6058 24.799 14.0729 24.2228 14.0729L1.77715 14.0729Z"
      />
    </svg>
  );
};

export default Cross;
